export const CONTRACT_AGREEMENTS = "/api/pa/Convention-contract-Types"
export const CONTRACT_AGREEMENT = "/api/pa/Convention-contract-Type/:param"
